import { ChevronDown, HelpCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { EyebrowBadge } from "../atoms/eyebrow-badge";
import { SectionHeading } from "../atoms/section-heading";

interface LandingFaqSectionProps {
	communityName: string;
}

const FAQ_KEYS = ["join", "pricing", "security", "delete_account", "support", "mobile_app", "languages", "unsubscribe"] as const;

export function LandingFaqSection({ communityName }: LandingFaqSectionProps) {
	const { t } = useTranslation("community");

	return (
		<section className="bg-background py-24 md:py-32">
			<div className="mx-auto flex w-full max-w-3xl flex-col items-center gap-12 px-6">
				<SectionHeading
					eyebrow={
						<EyebrowBadge tone="ink" icon={<HelpCircle size={14} />}>
							{t("landing.faq.eyebrow")}
						</EyebrowBadge>
					}
					title={t("landing.faq.title")}
				/>
				<div className="flex w-full flex-col gap-3">
					{FAQ_KEYS.map((key) => (
						<details
							key={key}
							className="landing-shadow-card group rounded-2xl border border-divider bg-content1 transition-colors open:bg-content2 [&[open]>summary>svg]:rotate-180"
						>
							<summary className="flex cursor-pointer items-center justify-between gap-4 rounded-2xl px-6 py-5 text-left text-base font-medium text-foreground marker:hidden [&::-webkit-details-marker]:hidden">
								<span>{t(`landing.faq.items.${key}.q`, { communityName })}</span>
								<ChevronDown className="h-5 w-5 shrink-0 text-foreground/50 transition-transform" aria-hidden />
							</summary>
							<p className="px-6 pb-5 text-sm leading-relaxed text-foreground/70">{t(`landing.faq.items.${key}.a`, { communityName })}</p>
						</details>
					))}
				</div>
			</div>
		</section>
	);
}
